const allowedModules = [
    'Client'
];
if (!allowedModules.includes(global.MODULE)) throw new Error(`Only allowed in ${allowedModules.join(', ')}`);
export * from './common/index.ts';
export * from './hooks/index.ts';
export * from './store/index.ts';
export * from './utils/index.ts';
